// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__Rbgdl","lds-default":"Loader_lds-default__I8Cu7"};